import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import HomePage from './pages/home/HomePage';
import SeriesPage from './pages/SeriesPage';
import SetsPage from './pages/SetsPage';
import SetCardsPage from './pages/SetCardsPage';
import Search from './pages/Search';
import Card from './pages/Card';
import AboutPage from './pages/info/AboutPage';
import ContactPage from './pages/info/ContactPage';
import PrivacyPage from './pages/info/PrivacyPage';
import LoginPage from './components/LoginPage';
import ProfilePage from './components/ProfilePage';
import EditProfilePage from './components/EditProfilePage';
import ProfileSetup from './components/ProfileSetup';
import AuthCallback from './components/AuthCallback';
import SettingsPage from './components/SettingsPage';
import Navbar from './components/Navbar';
import AppFooter from './components/layout/AppFooter';
import FeedbackWidget from './components/FeedbackWidget';
import './index.css';

function AppContent() {
  const location = useLocation();
  const hideChrome =
    location.pathname === '/login' ||
    location.pathname === '/profile-setup' ||
    location.pathname === '/auth/callback';
  const isHomePage = location.pathname === '/';

  return (
    <div className="min-h-screen">
      {!hideChrome && <Navbar />}
      
      <main className={hideChrome ? '' : isHomePage ? '' : 'container mx-auto px-4 py-8'}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/series" element={<SeriesPage />} />
          <Route path="/series/:seriesId" element={<SetsPage />} />
          <Route path="/sets/:setId" element={<SetCardsPage />} />
          <Route path="/search/:query" element={<Search />} />
          <Route path="/card/:cardId" element={<Card />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/profile/:username" element={<ProfilePage />} />
          <Route path="/edit-profile" element={<EditProfilePage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/profile-setup" element={<ProfileSetup />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
        </Routes>
      </main>
      {!hideChrome && <AppFooter />}
      <FeedbackWidget />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;
